import React from 'react';
import { Search, Calendar, User } from 'lucide-react';

const Header = ({ searchTerm, setSearchTerm, activeView, setActiveView }) => {
  return React.createElement('header', { className: 'header-glass' },
    React.createElement('div', { className: 'container' },
      React.createElement('div', { className: 'header-content' },
        React.createElement('div', { className: 'logo-section' },
          React.createElement('div', { className: 'logo-icon' },
            React.createElement(Calendar, { size: 32 })
          ),
          React.createElement('h1', { className: 'logo-text' }, 'Planorama')
        ),
        
        React.createElement('div', { className: 'search-section' },
          React.createElement('div', { className: 'search-container' },
            React.createElement(Search, { className: 'search-icon', size: 20 }),
            React.createElement('input', {
              type: 'text',
              placeholder: 'Search events...',
              value: searchTerm,
              onChange: (e) => setSearchTerm(e.target.value),
              className: 'search-input'
            })
          )
        ),
        
        React.createElement('nav', { className: 'nav-section' },
          React.createElement('button', {
            onClick: () => setActiveView('events'),
            className: `nav-button ${activeView === 'events' ? 'active' : ''}`
          }, 'Events'),
          React.createElement('button', {
            onClick: () => setActiveView('dashboard'),
            className: `nav-button ${activeView === 'dashboard' ? 'active' : ''}`
          },
            React.createElement(User, { size: 18 }),
            'Dashboard'
          )
        )
      )
    )
  );
};

export default Header;